import React from 'react';

interface PaginationProps {
  currentPage: number;
  pageSize: number;
  totalResults: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  pageSize,
  totalResults,
  onPageChange,
}: PaginationProps): React.ReactElement | null {
  if (totalResults <= pageSize) return null;

  const totalPages = Math.ceil(totalResults / pageSize);

  return (
    <div className="pagination" data-testid="pagination">
      <button
        type="button"
        className="pagination-btn"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label="Previous page"
      >
        ← Prev
      </button>
      <span>Page {currentPage} of {totalPages}</span>
      <button
        type="button"
        className="pagination-btn"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label="Next page"
      >
        Next →
      </button>
    </div>
  );
}
